"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var Item = function Item(_ref) {
  var children = _ref.children;
  return children;
};

Item.displayName = "Sortable.Item";
Item.propTypes = {
  children: _propTypes["default"].node.isRequired,
  sortId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired
};
var _default = Item;
exports["default"] = _default;
//# sourceMappingURL=Item.js.map